module.exports = __webpack_public_path__ + "img/krungsri.71c25878.jpg";